export default {
  engagementFeederTypes(state) {
    return state.engagementFeederTypes;
  },
};
